import React, { useState } from "react";
import styles from "./StyleGuide.module.css"; 
import NavBarImage from "../assets/Navbar-min.png";

import LOGO from "../assets/Logo-punchline.png";

import PropTypes from "prop-types"; // Ensure you have this installed


const ErrorModal = ({ show, onClose, title, message }) => {
  if (!show) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <h2 className={styles.modalTitle}>{title}</h2>
        <p className={styles.modalMessage}>{message}</p>
        <button className={styles.modalButton} onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

ErrorModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
};

const StyleGuide = () => {

  const [modalOpen, setModalOpen] = useState(false);

  return (
    <div className={styles.styleGuide}>
      
      <div className={styles.container}>
        {/* <NavBar /> */}
        <h1>PunchLine Style Guide</h1>
        <h2>LOGO</h2>
        <div className={styles.LogoContainer}>
        <img src={LOGO} alt="Logo" className={styles.LogoImage} />
        <img src={LOGO} alt="Logo" className={styles.LogoImageSmall} />
        <img src={LOGO} alt="Logo" className={styles.LogoImageSmallest} />
        </div>

        <h2>Navigation Bar</h2>
        <div className={styles.navbarExample}>
          <img src={NavBarImage} alt="Navbar" className={styles.navImage} />
          <span style={{ fontSize: '18px' }}>
          This is how the navigation bar appears when all dropdown menus are expanded. 
          Clicking on the profile icon reveals three options: Profile, Settings, and Log out. 
          The About Us dropdown displays the names of all our team members. 
          To close either menu, simply click the same item again.
          The search bar allows you to filter users, games, and posts. 
          The Create + button takes you to the post creation page. 
          The notification icon has two sections: one for earned badges and another for friend requests. 
          The Games tab leads to a game selection section, while the Friends tab displays your friend list.
          </span>

          <div className={styles.codeBox}>
<span className={styles.codeTitle}>CSS</span>
<pre>
{`
.searchWrapper {
display: flex;
align-items: center;
background-color: #C7D5E0;
border: 1.5px solid var(--color-text);
border-radius: 30px;
padding: 0.5px 8px;
width: 100%;
max-width: 75vh;
}


.searchBarContainer {
display: flex;
align-items: center;
background-color: #c9d7e0;
border-radius: 40px;
padding: 0.5vh 1vh;
height: 4vh;
max-width: 80vh;
width: 100%;
gap: 10px;
}

.searchIcon {
color: #1b2838;
font-size: 1.3rem;
margin-left: 8px;
}

.animatedSearchInput {
flex: 1;
border: none;
outline: none;
background: transparent;
font-size: 1rem;
color: #1b2838;
box-shadow: none;
}

.goSearchBtn {
background-color: #3498db;
color: white;
border: none;
border-radius: 999px;
padding: 8px 16px;
font-weight: bold;
font-size: 0.8rem;
cursor: pointer;
margin-left: 12px;
height: 2.2rem;
min-width: 2.2rem;
display: flex;
align-items: center;
justify-content: center;
}


.goSearchBtn:hover {
background-color: #66C0F4;
}

/* The overall navbar is fixed to the top and spans the full width */
.navbar-wrapper {
position: fixed;
top: 0; left: 0; right: 0;
z-index: 1000;
font-family: 'Secular One', sans-serif;
width: 100%;
}

/* The top row holds the logo, search bar, and action buttons */
.navbar-top {
display: flex;
align-items: center;
justify-content: space-between;
height: 6rem;
padding: 0 1.5rem;
background: var(--color-container);
}

/* The PunchLine logo on the left */


.logo {
font-size: 3.5vw;
font-weight: bold;
font-family: 'Secular One', sans-serif;
text-decoration: none;
cursor: pointer;
transition: opacity 0.2s ease-in-out;
color: var(--color-text);
flex-shrink: 0;
margin-right: 1vw;
}

.logo:hover {
opacity: 0.8;
}

/* The search box sits in the center of the top row */
.search-container {
flex: 1;
max-width: 50%;
margin: 0 2rem 0 1rem;
position: relative;
}
.search-icon {
position: absolute;
left: 9.5rem;
top: 50%;
transform: translateY(-50%);
color: #999;
font-size: 1.2rem;
}
.search-container input {
width: 55%;
height: 2.5rem;
border-radius: 999px;
border: none;
padding: 0 1rem 0 5rem;
background: var(--color-bg);
color: var(--color-text);
font-size: 1.25rem;
outline: none;

}

/* The right side contains, notifications, and profile */
.top-right {
display: flex;
align-items: center;
gap: 1.5rem;
margin-right: 0.5rem;
}


.btn-create {
background: #3498db;
color: var(--color-text);
padding: 0.4rem 0.7rem;
border-radius: .5rem;
text-decoration: none;
transition: background 0.2s, transform 0.2s;
white-space: nowrap;
}

.btn-create:hover {
transform: scale(1.1);
background-color: #66C0F4;
}


.bell-icon {
position: relative; /* Allow absolute children like ::after to align relative to this */
background: none;
border: none;
font-size: 1.5rem;
color: var(--color-text);
cursor: pointer;
z-index: 10;
left: 2vh;
}

.bell-icon.active::after {
content: "";
position: absolute;
top: 2px;
right: 2px;
width: 10px;
height: 10px;
background-color: red;
border: 2px solid var(--color-container);
border-radius: 50%;
}

/* Clicking the avatar shows profile links */
.profile-btn {
position: relative;
margin-top: 0.5rem;
color: var(--color-text);
font-size: 2.5rem;
cursor: pointer;
width: 100;
}
.profile-dropdown {
position:absolute;
top: 100%;
right:0;
margin-top: 0.5rem;
background: var(--color-container);
border-radius: 0.375rem;
box-shadow: 0 2px 6px rgba(0,0,0,0.4);
z-index: 1100;
font: 1rem;
padding: 0.5rem;
}
.profile-dropdown a,
.profile-dropdown button {
display: block;
padding: 0.5rem 1rem;
color: var(--color-text);
background: none;
border: none;
text-align: left;
text-decoration: none;
cursor: pointer;
white-space: nowrap;
}
.profile-dropdown a:hover,
.profile-dropdown button:hover {
background: var(--color-container-hover);
}

/* Ensure dropdown items fit nicely */
.profile-dropdown a,
.profile-dropdown button, .logout {
  font-size: 1.15rem;
  font-family: 'Secular One', sans-serif;
}

/* On small screens, show a menu toggle */
.icon-btn.menu {
font-size: 1.8rem;
}

/* The mobile menu slides down under the top bar */
.mobile-nav {
position: fixed;
top: 80px;
left: 0;
width: 100%;
height: calc(100% - 80px);
background: var(--color-container);
display: flex;
flex-direction: column;
align-items: center;
gap: 1.5rem;
padding-top: 1rem;
z-index: 1000;
}
.mobile-nav a,
.mobile-nav button.logout {
color: var(--color-text);
font-size: 1.2rem;
text-decoration: none;
background: none;
border: none;
width: 100%;
text-align: center;
padding: 0.75rem 0;
}
.mobile-nav button.logout {
background: #FF0000;
border-radius: 0.375rem;
}

/* The secondary bar sits directly below the top bar */
.navbar-secondary {
display: flex;
align-items: center;
gap: 2.5rem;
height: 3rem;
padding-left: 1.5rem;
background: var(--color-container-hover);
}

.navbar-secondary a,
.navbar-secondary .about-us {
color: var(--color-text);
font-size: 1.15rem;
text-decoration: none;
cursor: pointer;
}


.navbar-secondary > a:hover
{
opacity: 0.7;
}

.about-us {
position: relative;
margin-left: 0;
cursor: pointer;

}

.about-label {
color: var(--color-text);
font-size: 1.15rem;
font-weight: 100;
text-decoration: none;
transition: opacity 0.2s;
}

.about-label:hover {
opacity: 0.7;
}


.about-dropdown {
position: absolute;
top: 100%;
left: 50%;
transform: translateX(-50%);
margin-top: 0.25rem;
background: var(--color-container-hover);
border-radius: 0.375rem;
z-index: 1100;
}

.about-dropdown a {
display: block;
padding: 0.5rem 1rem;
color: var(--color-text);
text-decoration: none;
white-space: nowrap;
opacity: 1 !important;
text-align: center;
}

.about-dropdown a:hover {
color: grey;
}
.icon-btn {
background: none;
border: none;
color: var(--color-text);
font-size: 1.8rem;
cursor: pointer;
}
.icon-btn.bell {
position: relative;
}
.icon-btn.bell.active::after {
content: "";
position: absolute;
top: 0.2rem;
right: 0.2rem;
width: 0.45rem;
height: 0.45rem;
background: #ef4444;
border: 1.5px solid var(--color-container);
border-radius: 50%;
}

/* The notification panel floats over the page */
.notif-dropdown {
position: absolute;
top: 6.5rem;
right: 1rem;
width: 400px;
max-height: 400px;
background: var(--color-container);
color: var(--color-text);
border-radius: 0.5rem;
box-shadow: 0 4px 12px rgba(0,0,0,0.15);
overflow-y: auto;
}

.notification-header {
display: flex;
justify-content: space-between;
align-items: center;
padding: 0.5rem 1rem;
border-bottom: 1px solid rgba(0,0,0,0.1);
}


.notification-header h5 {
font-size: 1.4rem;
margin: 0;
}

.notification-header button {
background: none;
border: none;
font-size: 1.5rem;
cursor: pointer;
color: var(--color-text);
}

.notif-dropdown section h6 {
margin: 0 1rem 0.5rem;
font-size: 1.2rem;
font-weight: 600;
}


.request-item {
margin: 0.25rem;
padding: 0.5rem;
}
.accept-button, .reject-button {
padding: 0.25rem 0.5rem;
font-size: 0.8rem;
}

/* Notification card */
.notif-item {
position: relative;
margin: 0 1rem 0.5rem;
padding: 0.75rem 1rem;
background: var(--color-bg);
border: 1px solid rgba(0,0,0,0.08);
border-radius: 0.375rem;
transition: background 0.15s;
font-size: small;
}
.notif-item:hover { background:var(--color-container-hover) }
.notif-item-header {
display: flex;
justify-content: space-between;
align-items: center;
border-bottom: 1px solid rgba(0,0,0,0.1);
padding-bottom: 0.4rem;
margin-bottom: 0.4rem;
}
.notif-item-header .name {
font-size: 1rem;
font-weight: 700;
}
.notif-item-header .time {
font-size: 0.8rem;
color: var(--color-text);
}

/* sizes and rounds the avatar image */
.profile-icon {
width: 4rem;
height: 4rem;
border-radius: 50%;
object-fit: cover;
cursor: pointer;
border: 0.1rem var(--color-text) solid 
}

/* keeps “Log out” bold */
body,
#root > .App {
padding-top: 1rem;
background-color: var(--color-bg);
}




/* === Notification Dropdown === */
.notif-dropdown {
position: absolute;
top: 6rem;
right: .01rem;
width: 50vh;
max-height: 400px;
background: var(--color-container);
color: var(--color-text);
border-radius: 0 0 0.5rem 0.5rem;
box-shadow: none;
overflow-y: auto;
z-index: 1100;
}

.notif-dropdown::-webkit-scrollbar {
width: 0.65rem;

}
.notif-dropdown::-webkit-scrollbar-thumb {
background: var(--color-bg);
border-radius: 3px;

}

.notif-dropdown section {
padding: 1rem 0;
text-align: center;
}
.notif-dropdown section h6 {
/* margin: 0 0 0.5rem 2rem; */
font-size: 1.2rem;
font-weight: 2rem;
text-align: center;

}

/* Divider */
.notif-dropdown hr {
margin: 0;
border: none;
border-top: 5px solid rgba(0,0,0,0.1);
}

/* Header */
.notification-header {
display: flex;
justify-content: space-between;
align-items: center;
padding: 0.5rem 1rem;
border-bottom: 1px solid rgba(0,0,0,0.1);
}
.notification-header h5 {
font-size: 1.4rem;
margin: 0;
}
.notification-header button {
background: none;
border: none;
font-size: 1.5rem;
cursor: pointer;
color: var(--color-text);
}

/* Badge Notification Item */
.notif-item {
position: relative;
margin: 0 1rem 0.5rem;
padding: 0.8rem 1rem;
background: var(--color-bg);
border: 1px solid rgba(0,0,0,0.08);
border-radius: 0.375rem;
transition: background 0.15s;
font-size: small;
}
.notif-item:hover {
background: var(--color-container-hover);
}

.notif-item-header {
display: grid;
grid-template-columns: 1fr auto auto; /* left: name | right: time + x */
align-items: center;
gap: 0.75rem;
border-bottom: 1px solid rgba(0, 0, 0, 0.1);
padding-bottom: 0.4rem;
margin-bottom: 0.4rem;
}

.notif-item-header .name {
font-size: 1rem;
font-weight: 700;
margin: 0;
padding: 0;
text-align: left;
}

.notif-item-header .time {
font-size: 0.85rem;
color: var(--color-text);
text-align: right;
}

.close-btn {
background: none;
border: none;
font-size: 1.5rem;
color: #FF0000;
cursor: pointer;
transition: color 0.2s;
margin-left: 0.25rem;
font-weight: bold;
}


/* Friend Request Item */
.request-item {
display: flex;
justify-content: space-between;
align-items: center;
margin: 0 1rem 0.5rem;
padding: 0.75rem 1rem;
background-color: var(--color-bg);
border: 1px solid rgba(0, 0, 0, 0.08);
border-radius: 0.375rem;
font-size: 0.95rem;
font-weight: 600;
transition: background 0.15s;
}

.request-item .username {
flex: 1;
text-align: left;
}

.request-item .actions {
display: flex;
gap: 1rem;
}

.accept-button,
.reject-button {
padding: 0.35rem 0.75rem;
font-size: 0.85rem;
font-weight: bold;
border-radius: 0.25rem;
border: none;
cursor: pointer;
margin-left: auto;
gap: 20rem;
}

.accept-button {
background-color: #3498db;
color: white;
}

.reject-button {
background-color: #FF0000;
color: white;
}

.accept-button:hover {
background-color: #66C0F4;
}

.reject-button:hover {
background-color: #8B0000;
}

.friend-username {
flex: 1;
text-align: left;
white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;
max-width: 150px;
font-weight: 600;
}
.request-item .request-username{
text-decoration: none;
color: var(--color-text);
flex: 1;
text-align: left;
overflow: hidden;        /* clip overflowed text */
white-space: nowrap;     /* keep on one line */
text-overflow: ellipsis; /* show “…” when truncated */
}
`}
</pre>
</div>
        </div>

        <h2>Color Palette</h2>
        <div className={styles.colorBox}>
          <div className={styles.colorItem}>
            <div className={styles.banner}></div>
            <span>Top Banner: #1B2838</span>
          </div>
          <div className={styles.colorItem}>
            <div className={styles.background}></div>
            <span>Background: #2A475E</span>
          </div>
          <div className={styles.colorItem}>
            <div className={styles.sectionBackground}></div>
            <span>Div/Section Background: #C7D5E0</span>
          </div>
          <div className={styles.colorItem}>
            <div className={styles.buttonHover}></div>
            <span>Button Hover: #66C0F4</span>
          </div>
          <div className={styles.colorItem}>
            <div className={styles.createSubmitButtonHover}></div>
            <span>Create/Submit Button Hover: #3498db</span>
          </div>
          <div className={styles.colorItem}>
            <div className={styles.tags}></div>
            <span>Tags/Edit: #10DA53</span>
          </div>
          <div className={styles.colorItem}>
            <div className={styles.logoutColor}></div>
            <span>Logout/Exit:  #FF0000</span>
          </div>
          <div className={styles.colorItem}>
            <div className={styles.logouthover}></div>
            <span>Logout Hover: #8B0000</span>
          </div>
          <div className={styles.colorItem}>
            <div className={styles.TextTextbox}></div>
            <span>Text/Textbox: #FFFFFF</span>
          </div>
          <div className={styles.colorItem}>
            <div className={styles.SettingsDark}></div>
            <span>Settings Background: #111418</span>
          </div>
          <div className={styles.colorItem}>
            <div className={styles.SettingsLight}></div>
            <span>Settings Background (Light Mode): #F8F9FF</span>
          </div>

          <div className={styles.colorItem}>
            <div className={styles.signColor}></div>
            <span>Sign/Log In Button: #006400</span>
          </div>

          <div className={styles.colorItem}>
            <div className={styles.reset1}></div>
            <span>Reset Password Button: #ff4500</span>
          </div>

          <div className={styles.colorItem}>
            <div className={styles.reset2}></div>
            <span>Reset Password Button (Hover): #cc3700</span>
          </div>

        </div>
        
        <h2>Typography (Sans-Serif)</h2>
        <table className={styles.fontTable}>
          <thead>
            <tr>
              <th>Font Type (Primary): Secular One</th>
              <th>Additional Font Type (Secondary): Verdana</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className={styles.secularBoldLarge}>PunchLine: NavBar</td>
              <td className={styles.verdanaBoldLarge}>PunchLine: NavBar</td>
            </tr>
            <tr>
              <td className={styles.secularLarge}>PunchLine: Button Text</td>
              <td className={styles.verdanaLarge}>PunchLine: Button Text</td>
            </tr>
            <tr>
              <td className={styles.secularBoldMedium}>PunchLine: Tags/Sub-Options</td>
              <td className={styles.verdanaBoldMedium}>PunchLine: Tags/Sub-Options</td>
            </tr>
            <tr>
              <td className={styles.secularMedium}>PunchLine: Post Text</td>
              <td className={styles.verdanaMedium}>PunchLine: Post Text</td>
            </tr>
          </tbody>
        </table>

        <div className={styles.textSampleContainer}>
          <span className={styles.secularText}>
             Secular: Text Styling will be in "Bold" in instances when text is in a button, a descriptor for certain elements -
             such as "Trending Games" or the "Sort By" feature. Dropdown items may also be bold for visual clarity but the filter and 
             search aspect of the dropdown must not be bold. 
             The font sizing for all text in the aforementioned elements must be of font size 24 or in general, have a REM (Root Em) 
             unit of 1.1 to 1.5rem. The Banner text as comparison is set to a rem value of 3. Post Text, which includes title, body, 
             comments, and "Likes" must not be bold and of size 18px or 1.1rem
          </span>
          <p></p>
          <span className={styles.verdanaText}> Verdana: Text Styling will be in "Bold" in instances when text is in a button, a descriptor for certain elements -
             such as "Trending Games" or the "Sort By" feature. Dropdown items may also be bold for visual clarity but the filter and 
             search aspect of the dropdown must not be bold. 
             The font sizing for all text in the aforementioned elements must be of font size 24 or in general, have a REM (Root Em) 
             unit of 1.1 to 1.5rem. The Banner text as comparison is set to  a rem value of 3. Post Text, which includes title, body, 
             comments, and "Likes" must not be bold and of size 18px or 1.1rem
             </span>
        </div>
        
        <h2>User Interface and Feedback</h2>
        <h3>Buttons with Example Behavior</h3>
        <div className={styles.buttonRow}>
          <div>
            <button className={styles.createButtonStatic}>Create +</button>
          </div>
          <div>
            <button className={styles.createButtonHover}>Create +</button>
          </div>
          <span className={styles.buttonText}>Example Create+ Button: </span>
          <button className={styles.createButton}>Create +</button> 
        </div>

        <div className={styles.buttonRow}>
          <div>
            <button className={styles.logoutStatic}>Logout</button>
          </div>
          <div>
            <button className={styles.logoutHover}>Logout</button>
          </div>
          <span className={styles.buttonText}>Example Logout Button: </span>
          <button className={styles.logout}>Logout</button> 
        </div>

        <div className={styles.buttonRow}>
          <div>
            <button className={styles.loginButtonStatic}>Login</button>
          </div>
          <div>
            <button className={styles.loginButtonHoverStatic}>Login</button>
          </div>
          <span className={styles.buttonText}>Example Login Button: </span>
          <button className={styles.loginButton}>Login</button> 
        </div>

        <div className={styles.buttonRow}>
          <div>
            <button className={styles.signupStatic}>Sign Up</button>
          </div>
          <div>
            <button className={styles.signupHoverStatic}>Sign Up</button>
          </div>
          <span className={styles.buttonText}>Example Sign Up Button: </span>
          <button className={styles.signup}>Sign Up</button> 
        </div>

        <div className={styles.buttonRow}>
          <div>
            <button className={styles.resetStatic}>Reset Password</button>
          </div>
          <div>
            <button className={styles.resetHoverStatic}>Reset Password</button>
          </div>
          <span className={styles.buttonText}>Example Reset Password Button: </span>
          <button className={styles.reset}>Reset Password</button> 
        </div>


        <div className={styles.buttonRow}>
          <div>
            <button className={styles.postbutton}>submit</button>
            <span>    No Hover Behavior</span>
          </div>
        </div>

        <div className={styles.buttonRow}>
          <div>
            <button className={styles.editbutton}>Edit</button>
            <span>    No Hover Behavior</span>
          </div>

        </div>

        <h3>Buttons with Example Behavior (All Code)</h3>
        <div className={styles.codeBox}>
<span className={styles.codeTitle}>CSS</span>
<pre>
{`.createButton {
    text-decoration: none;
    display: inline-block;
    background-color: #66C0F4;
    color: white;
    font-size: 1.5rem;
    font-weight: bold;
    padding: 10px 15px;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.2s;
}

.createButton:hover {
    background-color: #3498db;
    transform: scale(1.1);
}

.logout {
    background-color: red;
    text-decoration: none;
    display: inline-block;
    color: white;
    font-size: 1.5rem;
    font-weight: bold;
    padding: 10px 15px;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.2s;
  }
  
  
.logout:hover {
background-color: darkred;
transform: scale(1.1);
}


.loginButton {
    width: 20%;
    height: 50px;
    border: none;
    border-radius: 25px;
    background: linear-gradient(90deg, #006400, #008000);
    color: white;
    font-family: Poppins, sans-serif;
    font-size: 18px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.3s ease;
}


.loginButton:hover {
    background: linear-gradient(90deg, #008000, #00b300);
}


.signup {
    font-family: 'Secular One', sans-serif;
    font-size: 16px;
    font-weight: bold;
    border: none;
    border-radius: 8px;
    padding: 12px 24px;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    text-align: center;
    display: inline-block;
    background-color: #008000; /* Green */
    color: white;
}

.signup:hover {
    background-color: #006400; /* Darker Green */
}

.reset {
    font-family: 'Secular One', sans-serif;
    font-size: 16px;
    font-weight: bold;
    border: none;
    border-radius: 8px;
    padding: 12px 24px;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    text-align: center;
    display: inline-block;
    background-color: #ff4500; /* Orange-Red */
    color: white;
}

.reset:hover {
    background-color: #cc3700; /* Darker Red */
}


.post-button {
  background-color: #66C0F4; 
  color: white; 
  border: none;
  padding: 10px 55px;
  margin: 10px 0; 
  border-radius: 5px;
  cursor: pointer;
  font-size: 20px;
  transition: background-color 0.3s ease; 
}

.edit-button{
  background-color: #10DA53;
  color: white;
  font-size: 20px;
  padding: 10px 15px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}
`}
</pre>
</div>

        <h3>Dropdown Example (Static)</h3>
        <div className={styles.dropdownExample}>
          <div className={styles.dropdownStatic}>
            <div className={styles.searchInput}>Example Closed</div>
          </div>
          <div className={styles.dropdownActive}>
            <div className={styles.searchInput}>Example Open Dropdown</div>
            <div className={styles.dropdownContent}>
              <div className={styles.dropdownItem}>Option 1</div>
              <div className={styles.dropdownItem}>Option 2</div>
              <div className={styles.dropdownItem}>Option 3</div>
            </div>
          </div>
        </div>
        <div className={styles.codeBox}>
<span className={styles.codeTitle}>CSS</span>
<pre>
{`
.dropdown {
  position: relative;
  width: 20%;
}

.search-input {
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  border: none;
  background-color: #c7d5e0;
  color: black;
  cursor: pointer;
  align-self: flex-start;
}

.dropdown-content {
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #ffffff;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  z-index: 1000;
  width: 110%;
  max-height: 150px;
  overflow-y: auto;
  display: none;
}

.dropdown-content.show {
  display: block;
}

.dropdown-item {
  padding: 10px;
  cursor: pointer;
  color: black;
  background-color: white;
  transition: background 0.2s;
}

.dropdown-item:hover {
  background-color: #c7d5e0;
}


`}
</pre>
</div>

        <h2>Modal</h2>
        <p>This is an example of an error modal that is used through the Webpage.</p>
        <button className={styles.modalButton} onClick={() => setModalOpen(true)}>
          Show Modal Example
        </button>

        <ErrorModal
          show={modalOpen}
          onClose={() => setModalOpen(false)}
          title="Example Error"
          message="Example Modal Text Here."
        />

        <div className={styles.codeBox}>
                  <span className={styles.codeTitle}>CSS</span>
                  <pre>
{`
.modalOverlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}
  
.modalContent {
    background: rgba(255, 255, 255, 0.9);
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
    text-align: center;
    width: 350px;
    max-width: 90%;
}
  
.modalTitle {
    font-size: 20px;
    font-weight: bold;
    color: #333;
    margin-bottom: 10px;
}
  
.modalMessage {
    font-size: 16px;
    color: #555;
    margin-bottom: 20px;
}
  
.modalButton {
    background: #d9534f;
    color: white;
    border: none;
    padding: 10px 20px;
    font-size: 16px;
    border-radius: 5px;
    cursor: pointer;
    transition: background 0.3s ease;
    margin-top: 10px;
}
  
.modalButton:hover {
    background: #c9302c;
}

`}
                  </pre>
        </div>

      
      </div>
    </div>
  );
};


export default StyleGuide;


